import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { ClienteRequest, Response } from './Types';

interface ClienteRelatorioRequest {
  ClienteId?: number | null | undefined;
  ClienteNome?: string;
  ProdutoId?: number | null;
  Periodo?: number;
}

class ClienteController {
  public static async Listar(request: ClienteRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/cliente/Listar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object, ErroDetalhado: undefined };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        // [14/08/2026] O detalhe do banco CHEGAVA e era jogado fora aqui - "undefined"
        // chapado. A API manda Erro e ErroDetalhado no corpo (ClienteController.cs), e a
        // proc ja devolve mensagem pronta e legivel, do tipo "Cliente ja cadastrado no
        // sistema, verifique!". Nada disso chegava na tela.
        ErroDetalhado: error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro,
      };
      return retorno;
    }
  }

  public static async ListarVendedor(nome: string): Promise<Response> {
    try {

      const response = await Api.get(`api/cliente/ListarVendedor?Nome=${nome}`);

      const object = response?.data;
      return { StatusCode: response.status, Data: object, ErroDetalhado: undefined };
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        // [14/08/2026] O detalhe do banco CHEGAVA e era jogado fora aqui - "undefined"
        // chapado. A API manda Erro e ErroDetalhado no corpo (ClienteController.cs), e a
        // proc ja devolve mensagem pronta e legivel, do tipo "Cliente ja cadastrado no
        // sistema, verifique!". Nada disso chegava na tela.
        ErroDetalhado: error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro,
      };
      return retorno;
    }
  }

  public static async ListarTransportador(nome: string): Promise<Response> {
    try {
      const response = await Api.get(`api/cliente/ListarTransportador?Nome=${nome}`);

      const object = response?.data;
      return { StatusCode: response.status, Data: object, ErroDetalhado: undefined };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        // [14/08/2026] O detalhe do banco CHEGAVA e era jogado fora aqui - "undefined"
        // chapado. A API manda Erro e ErroDetalhado no corpo (ClienteController.cs), e a
        // proc ja devolve mensagem pronta e legivel, do tipo "Cliente ja cadastrado no
        // sistema, verifique!". Nada disso chegava na tela.
        ErroDetalhado: error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro,
      };
    }
  }

  /**
   * Extrato da conta corrente do cliente.
   *
   * Sem o `[0]` que o ListarUnico usa: aqui a resposta e uma LISTA de movimentos, e
   * lista vazia e resposta legitima - a maioria dos clientes nunca teve credito.
   */
  /**
   * Quanto de crédito o cliente tem para usar NESTE pedido.
   *
   * Não é o saldo: num pedido que já usou crédito, o saldo atual já está debitado, e a
   * procedure soma de volta o que este pedido consumiu. Sem isso, editar um pedido
   * pareceria ter menos crédito do que existe. Ver o script 140.
   */
  public static async CreditoDisponivel(
    clienteId: number,
    vendaId?: number | null
  ): Promise<Response> {
    try {
      const query = vendaId ? `?vendaId=${vendaId}` : '';
      const response = await Api.get(
        `api/cliente/CreditoDisponivel/${clienteId}${query}`
      );
      return { StatusCode: response.status, Data: response?.data ?? [] };
    } catch (error: any) {
      // Falha na consulta não pode travar o pedido: o campo fica zerado e o operador
      // simplesmente não usa crédito nesta gravação.
      return { StatusCode: error?.response?.status, Data: [] };
    }
  }

  public static async ContaCorrente(clienteId: number): Promise<Response> {
    try {
      const response = await Api.get(`api/cliente/ContaCorrente/${clienteId}`);
      return { StatusCode: response.status, Data: response?.data ?? [] };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: [],
        ErroDetalhado: error?.response?.data?.ErroDetalhado,
      };
    }
  }

  public static async ListarUnico(clienteId: number): Promise<Response> {
    try {
      const response = await Api.get(`api/cliente/ListarUnico/${clienteId}`);

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
        ErroDetalhado: undefined
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        ErroDetalhado: undefined
      };
      return retorno;
    }
  }

  public static async Adicionar(request: ClienteRequest): Promise<Response> {
    try {

      const response = await Api.post(`api/cliente/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object, ErroDetalhado: undefined };
      return retorno;

    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        // [14/08/2026] O detalhe do banco CHEGAVA e era jogado fora aqui - "undefined"
        // chapado. A API manda Erro e ErroDetalhado no corpo (ClienteController.cs), e a
        // proc ja devolve mensagem pronta e legivel, do tipo "Cliente ja cadastrado no
        // sistema, verifique!". Nada disso chegava na tela.
        ErroDetalhado: error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro,
      };
      return retorno;
    }
  }

  public static async Atualizar(request: ClienteRequest): Promise<Response> {
    try {

      const response = await Api.put(`api/cliente/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object, ErroDetalhado: undefined };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        // [14/08/2026] O detalhe do banco CHEGAVA e era jogado fora aqui - "undefined"
        // chapado. A API manda Erro e ErroDetalhado no corpo (ClienteController.cs), e a
        // proc ja devolve mensagem pronta e legivel, do tipo "Cliente ja cadastrado no
        // sistema, verifique!". Nada disso chegava na tela.
        ErroDetalhado: error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro,
      };
      return retorno;
    }
  }

  public static async Excluir(request: ClienteRequest): Promise<Response> {
    try {
      const response = await Api.put(`api/cliente/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object, ErroDetalhado: undefined };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        // [14/08/2026] O detalhe do banco CHEGAVA e era jogado fora aqui - "undefined"
        // chapado. A API manda Erro e ErroDetalhado no corpo (ClienteController.cs), e a
        // proc ja devolve mensagem pronta e legivel, do tipo "Cliente ja cadastrado no
        // sistema, verifique!". Nada disso chegava na tela.
        ErroDetalhado: error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro,
      };
      return retorno;
    }
  }

  public static async Relatorio(request: ClienteRelatorioRequest): Promise<Response> {
    try {
      console.log('Requisição do Relatório:', request);
      const response = await Api.post(`api/relatorio/Clientes`, request);

      const retorno: Response = { StatusCode: response.status, Data: response.data, ErroDetalhado: undefined };
      console.log('Resposta do Relatório:', retorno);
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
        // [14/08/2026] O detalhe do banco CHEGAVA e era jogado fora aqui - "undefined"
        // chapado. A API manda Erro e ErroDetalhado no corpo (ClienteController.cs), e a
        // proc ja devolve mensagem pronta e legivel, do tipo "Cliente ja cadastrado no
        // sistema, verifique!". Nada disso chegava na tela.
        ErroDetalhado: error?.response?.data?.ErroDetalhado ?? error?.response?.data?.Erro,
      };
      return retorno;
    }
  }
}
export default ClienteController;
